import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  buildTextSpan,
  translateAllHtml
} from './helpers'

let {
  supportedLanguages,
  languageDetection
} = window.multilingual_settings;

i18next.use(LanguageDetector).init({
  detection: {
    // order and from where user language should be detected
    order: languageDetection || ['cookie', 'navigator', 'path', 'subdomain'],

    // keys or params to lookup language from
    lookupCookie: 'language',
    lookupFromPathIndex: 0,
    lookupFromSubdomainIndex: 0,

    // cache user language on
    caches: [ 'cookie'],
  },
  fallbackLng: (code) => {
    let fallbackLanguage = [...supportedLanguages];
    //if detected language is supported we don't need a fallback 
    //so we just keep the same language
    if(fallbackLanguage.includes(code)) {
      return fallbackLanguage.sort((a, b) => {
        if (a === code) {
          return -1;
        }
        else {
          return 1;
        }
      });
    }

    //if not we check if there's a match without the regional code
    //and fallback to the match
    const codeWithoutRegion = code.split('-')[0];
    if(fallbackLanguage.includes(codeWithoutRegion)) {
      i18next.language = codeWithoutRegion;
      return fallbackLanguage.sort((a) => {
        if (a === codeWithoutRegion) {
          return -1;
        }
        else {
          return 1;
        }
      });
    }

    //otherwise we just fallback to the primary language
    i18next.language = fallbackLanguage[0];
    return fallbackLanguage;
  },
});

i18next.buildTextSpan = buildTextSpan;
i18next.translateAllHtml = translateAllHtml;

//Handlebars translation helper
document.addEventListener("DOMContentLoaded", function(event) {
  if (typeof Handlebars !== 'undefined') {
    Handlebars.registerHelper('translation', function (text) {
      return buildTextSpan(text);
    });
  }
});


//to help debug
window.i18next = i18next;

export {
  i18next
}